import { useTranslation } from 'react-i18next';
import type { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';

export const useProviderName = (sourceSystem: WorkIntegration_Keys): string => {
  const { t } = useTranslation();
  return t(($) => $.common.settings['work-integrations'].providerName[sourceSystem]);
};
